import { SpacingValues } from "@/lib/utils/SpacingValues";
import { ByCustomerNumberOrIndexFragment } from "@/gql/graphql";
import { Spacing } from "@stenajs-webui/core";
import { LoadingScreen } from "@stenajs-webui/panels";
import * as React from "react";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import {
  CopyHeadAgreementFetcher,
  useCopyHeadAgreementTargetCustomerQuery,
} from "../CopyHeadAgreementFetcher";
import { CopyHaFromOtherCustomerHeader } from "./CopyHaFromOtherCustomerHeader";
import { SelectCustomerAndHaToCopyFrom } from "./SelectCustomerAndHaToCopyFrom";
import { useGetCopyToCustomerQuery } from "./hooks/UseCopyToOtherCustomerBreadCrumbName";

export const customerInitialState: ByCustomerNumberOrIndexFragment = {
  id: "",
  name: "",
  custNo: 0,
  custIndex: "",
};

export const CopyHaFromOtherCustomerScreen: React.FC = () => {
  const { headAgreementId, customerId } = useParams() as {
    customerId: string;
    headAgreementId: string;
  };

  const [copyHeadAgreementView, setCopyHeadAgreementView] = useState(false);

  const [copyFromCustomer, setCopyFromCustomer] =
    useState<ByCustomerNumberOrIndexFragment>(customerInitialState);
  const [copyFromHeadAgreementId, setCopyFromHeadAgreementId] = useState("");

  const { copyToCustomer, customerLoading } =
    useGetCopyToCustomerQuery(customerId);

  const {
    targetHeadAgreement: copyToHeadAgreement,
    getTargetCustomerByQuery: getCopyToHeadAgreementById,
    loading,
  } = useCopyHeadAgreementTargetCustomerQuery(headAgreementId);

  useEffect(() => {
    getCopyToHeadAgreementById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (customerLoading) {
    return (
      <Spacing num={SpacingValues.TWENTYFOUR}>
        <LoadingScreen />
      </Spacing>
    );
  }

  return (
    <>
      <Helmet title="Copy HA to other customer - Customer - FPP" />
      <CopyHaFromOtherCustomerHeader
        customerId={customerId}
        headAgreementId={headAgreementId}
      />
      {copyHeadAgreementView ? (
        <CopyHeadAgreementFetcher
          headAgreementId={copyFromHeadAgreementId}
          targetHeadAgreement={copyToHeadAgreement ?? undefined}
          targetCustomer={copyToCustomer ?? customerInitialState}
          copyHaFromOtherCustomer
        />
      ) : (
        <SelectCustomerAndHaToCopyFrom
          copyFromCustomer={copyFromCustomer}
          copyFromHeadAgreementId={copyFromHeadAgreementId}
          loading={loading}
          selectButtonDisabled={
            (!copyFromCustomer && !copyFromHeadAgreementId) ||
            copyFromHeadAgreementId === "" ||
            loading
          }
          setCopyFromCustomer={setCopyFromCustomer}
          setCopyFromHeadAgreementId={setCopyFromHeadAgreementId}
          rightButtonOnClick={() => {
            copyFromCustomer &&
              copyFromHeadAgreementId &&
              setCopyHeadAgreementView(true);
          }}
        />
      )}
    </>
  );
};
